document.addEventListener("DOMContentLoaded", function () {
  (function(){
    /********REMOVING UNWANTED ELEMENTS ON DIFFERENT SCREEN********/
    if(window.innerWidth >= 769){
      document.querySelectorAll(".desktop__hide")?.forEach(function(e){e.remove()});
    }else{
      document.querySelectorAll(".mobile__hide")?.forEach(function(e){e.remove()});
    }
  
    /*******TRENDING SLIDER FUNCTIONALITY******/
    const trendingSlider = new Swiper(".drawer_trending_slider",{
      slidesPerView: 3,
      spaceBetween: 5,
      slidesPerGroup: 3,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    })
  
    /*****CATEGORIES SLIDER FUNCTIONALITY******/
    const categories = new Swiper(".categories--slider",{
      slidesPerView: 4,
      centeredSlides: true,
      loop: true,
      spaceBetween: 30,
      slideToClickedSlide: true,
      breakpoints: {
        320: {
          slidesPerView: 4,
          spaceBetween: 20,
        },
        400: {
          slidesPerView: 4
        },
        768: {
          slidesPerView: 6,
          spaceBetween: 30,
        },
        991: {
          slidesPerView: 8
        }
      }
    })
  
    /*****GIFT CART SLIDER****/
    const giftSlider = new Swiper(".gift__block--variants-wrapper",{
      slidesPerView: "auto",
      spaceBetween: 25,
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      }
    })
  
    /*****GIFT ADDING INTO CART FUNCTIONALITY*****/
  
    const giftTriggers = document.querySelectorAll("[gift--add-to-cart]");
    if(giftTriggers.length > 0){
      giftTriggers.forEach(e=>{
        e.addEventListener("click",function(){
          const element = this;
          const productId = this.dataset.id;
          if(productId){
            element.classList.add('btn--loading');
            let formData = {
             'items': [{
               id: productId,
               quantity: 1,
               properties: {
                  '': 'Free Gift'
                }
              }]
            };
            fetch(window.Shopify.routes.root + 'cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(formData)
            })
            .then(response => {
              return response.json();
            })
            .then(function(data) {
              if (data.status === 422) {
                console.error(data);
              }
              else{
                document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
                  detail: {
                    product: data
                  }
                }));
                element.closest("#CartDrawerForm")?.classList.add("gift_added");
              }
              element.classList.remove('btn--loading');
              
            })
            .catch((error) => {
              console.error('Error:', error);
            });
          }
        })
      })
      
        const gift_ids = [49176772116754,
49176772968722];
        let free_gift_amount = "390000";
        
        document.addEventListener("cart:buildup",function(){
          theme.cart.getCart().then(response => { 
            console.log(response);
            const items = response.items;
            if(items){
              let giftPresent = false;
              items.forEach(e =>{
                const variant_id = e.variant_id;
                if(gift_ids.includes(variant_id)){
                  giftPresent = true;
                }
              })
              if(!giftPresent){
                document.querySelector("#CartDrawerForm")?.classList.remove("gift_added");
              }else{
                document.querySelector("#CartDrawerForm")?.classList.add("gift_added");
              }
            }
            if(response.total_price < Number(free_gift_amount) ){
              if(items){
              items.forEach(e =>{
                const variant_id = e.variant_id;
                if(gift_ids.includes(variant_id)){
                    setTimeout(function(){
                      let formData = {
                     id: `${variant_id}`,
                     quantity: 0
                  };
                  fetch(window.Shopify.routes.root + 'cart/change.js', {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(formData)
                  })
                  .then(response => {
                    return response.json();
                  })
                  .then(function(data) {
                    if (data.status === 422) {
                      console.error(data);
                    }
                    else{
                      document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
                        detail: {
                          product: data
                        }
                      }));
                    }
                  })
                  .catch((error) => {
                    console.error('Error:', error);
                  });
                    },500)
                  
                }
              })
            }
            }
          });
        })
      
    }
  
    /********VARIANT SWATCH SHOW FUNCTIONALITY*****/
  
    if(window.innerWidth < 768){
      const remaining_swatches_trigger = document.querySelector("[remaining-swatches-trigger]");
      if(remaining_swatches_trigger){
        remaining_swatches_trigger.addEventListener("click",function(){
          this.closest("[color-swatch-main]").querySelector("[remaing-swatches]")?.classList.add("active");
          this.classList.add("visually-hidden");
        })
      }
    }
    // if(window.innerWidth < 768){
    //   const colorVariantBox = document.querySelector("[color--variant-main] [color--variant-box]");
    //   if(colorVariantBox){
    //     const height = colorVariantBox.clientHeight;
    //     if(height > 60){
    //       const trigger = colorVariantBox.closest("[color--variant-main]").querySelector("[showTrigger]");
    //       if(trigger){
    //         colorVariantBox.style.setProperty('--element-height', height + "px");
    //         colorVariantBox.classList.add("active_field");
    //         trigger.classList.remove("visually-hidden");
    //         trigger.addEventListener("click",function(){
    //           this.classList.toggle("active_field");
    //           colorVariantBox.classList.toggle("active_field");
    //         })
    //       }
    //     }
    //   }
    // }
    /********PROMOTION BANNER SLIDER*******/
    const promotionBannerSlider = new Swiper(".promotion--banner-slider",{
      slidesPerView: 1.1,
      spaceBetween: 15,
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      },
    })
    
    // Init section function when it's visible, then disable observer
    theme.initWhenVisible = function(options) {
      const threshold = options.threshold ? options.threshold : 0;
    
      const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            if (typeof options.callback === 'function') {
              options.callback();
              observer.unobserve(entry.target);
            }
          }
        });
      }, {rootMargin: `0px 0px ${threshold}px 0px`});
    
      observer.observe(options.element);
    };
    
    class ScrollingPromotion extends HTMLElement {
      constructor() {
        super();
    
        this.config = {
          moveTime: parseFloat(this.dataset.speed), // 100px going to move for
          space: 100, // 100px
        };
    
        this.promotion = this.querySelector('.promotion');
    
        theme.initWhenVisible({
          element: this,
          callback: this.init.bind(this),
          threshold: 600
        });
      }
    
      init() {
        if (this.childElementCount === 1) {
          this.promotion.classList.add('promotion--animated');
    
          for (let index = 0; index < 10; index++) {
            this.clone = this.promotion.cloneNode(true);
            this.clone.setAttribute('aria-hidden', true);
            this.appendChild(this.clone);
    
            const imageWrapper = this.clone.querySelector('.media-wrapper');
            if (imageWrapper) {
              imageWrapper.classList.remove('loading');
            }
          }
    
          const animationTimeFrame = (this.promotion.clientWidth / this.config.space) * this.config.moveTime;
          this.style.setProperty('--duration', `${animationTimeFrame}s`);
    
          // pause when out of view
          const observer = new IntersectionObserver((entries, _observer) => {
            entries.forEach(entry => {
              if (entry.isIntersecting) {
                this.scrollingPlay();
              } else {
                this.scrollingPause();
              }
            });
          }, {rootMargin: '0px 0px 50px 0px'});
    
          observer.observe(this);
        }
      }
    
      scrollingPlay() {
        this.classList.remove('scrolling-promotion--paused');
      }
    
      scrollingPause() {
        this.classList.add('scrolling-promotion--paused');
      }
    }
    customElements.define('scrolling-promotion', ScrollingPromotion);
  
    /*******CUSTOM CHAT BUTTON STYLING*******/
    
      const custom_chat__icon = document.querySelectorAll("[custom_chat__icon]");
      if(custom_chat__icon.length > 0){
        custom_chat__icon.forEach(function(e){
          e.addEventListener("click",function(){
            document.querySelector("#dummy-chat-button-iframe")?.contentWindow.document.getElementById("dummy-chat-button").click();
            if(document.querySelector("inbox-online-store-chat#ShopifyChat")){
              document.querySelector("#ShopifyChat").shadowRoot.querySelector(".chat-app button.chat-toggle").click();
            }else{
              document.querySelector("#ShopifyChat")?.contentWindow.document.querySelector("button.chat-toggle").click();
            }
          })
        })
      }
    
      function shopifyChat(selector) {
        return new Promise(resolve => {
            if (document.querySelector(selector)) {
                return resolve(document.querySelector(selector));
            }
    
            const observer = new MutationObserver(mutations => {
                if (document.querySelector(selector)) {
                    observer.disconnect();
                    resolve(document.querySelector(selector));
                }
            });
    
            observer.observe(document.body, {
                childList: true,
                subtree: true
            });
        });
      }
  
      function removeAttr(){
        const live_chat_trigger = document.querySelectorAll("[live_chat_trigger]");
        if(live_chat_trigger.length > 0){
          live_chat_trigger.forEach(function(e){
            e.removeAttribute("disabled");
          })
        }
      }
      shopifyChat('#dummy-chat-button-iframe').then((elm) => {
        elm.contentWindow.document.getElementById("dummy-chat-button").style.display = "none";
        const live_chat_trigger = document.querySelectorAll("[live_chat_trigger]");
        removeAttr();
      });
    
      shopifyChat('#ShopifyChat').then((elm) => {
        setTimeout(function(){
          let buttonStyling = "<style>button.chat-toggle{display: none !important;}</style>";
          if(document.querySelector("inbox-online-store-chat#ShopifyChat")){
            document.querySelector("#ShopifyChat").shadowRoot.querySelector(".chat-app").insertAdjacentHTML('beforebegin',buttonStyling);
          }else{
            document.querySelector("#ShopifyChat").contentWindow.document.body.insertAdjacentHTML('afterbegin',buttonStyling);
          }
          removeAttr();
        },2000)
      });
  
    /*********DRAWER CONTACT TRIGGERS*********/
  
  
      function openContactDrawer(trigger){
        const mobile_chat_popup = document.querySelector("[custom_chat_mobile]");
        if(mobile_chat_popup){
           if(trigger){
              mobile_chat_popup.classList.add("contact_popup_active");
              document.body.classList.add("contact_popup_active");
           }
           else{
              mobile_chat_popup.classList.remove("contact_popup_active");
              document.body.classList.remove("contact_popup_active");    
           }
        }
      }
      const drawer_contact_trigger = document.querySelectorAll("[drawer_contact_trigger]");
      if(drawer_contact_trigger.length > 0){
        drawer_contact_trigger.forEach(function(e){
          e.addEventListener("click",function(){
            openContactDrawer(true);
          })
        })
      }
      
      const custom_chat_mobile_close = document.querySelectorAll("[custom_chat_mobile_close]");
      if(custom_chat_mobile_close.length > 0){
        custom_chat_mobile_close.forEach(function(e){
          e.addEventListener("click",function(ele){
            openContactDrawer(false);
          })
        })
      }
  
      const custom_chat_mobile_back_trigger = document.querySelectorAll("[custom_chat_mobile_back_trigger]");
      if(custom_chat_mobile_back_trigger.length > 0){
        custom_chat_mobile_back_trigger.forEach(function(e){
          e.addEventListener("click",function(ele){
            ele.stopPropagation();
            ele.stopImmediatePropagation();
            openContactDrawer(false);
          })
        })
      }
    const foundLabel = document.querySelector(".product--page--new-tag.grid-product__tag");
    const foundLimitedLabel = document.querySelector(".product--page--limited-stock.grid-product__tag");
    document.addEventListener("variant:change",function(){
      const foundElement = document.querySelectorAll(".product-section input[type='radio'][enable--new-in]");
      const foundElement2 = document.querySelector(".product-section .dropdown__filter-selected .custom--color-dropdown-item-wrapper[enable--new-in]");
      let checkedElement = false;
      if(foundElement.length > 0){
        foundElement.forEach(function(e){
          if(e.checked == true){
             checkedElement = true;
          }
        })
      }
      else if(foundElement2){
        checkedElement = true;
      }
      if(checkedElement){
        foundLabel?.classList.add("active");
        foundLimitedLabel?.classList.add("active");
      }else{
        foundLabel?.classList.remove("active");
        foundLimitedLabel?.classList.remove("active");
      }
    })
  
  
    // Change option selected
    const label = document.querySelector('.dropdown__filter-selected')
    const options = Array.from(document.querySelectorAll('.dropdown__select-option'))
    const hiddenInput = document.querySelector(".custom--color-dropdown");
    
    options.forEach((option) => {
        option.addEventListener('click', function(){
            label.innerHTML = option.innerHTML;
            document.querySelectorAll('.dropdown__select-option.active')?.forEach(e=>{e.classList.remove('active')});
            option.classList.add('active');
            if(hiddenInput){
              let value = this.getAttribute("value");
              const foundElement = this.closest("[variant-input-wrap]").querySelector("select");
              if(foundElement){
                const foundOption = foundElement.querySelector("option[value='"+value+"']");
                foundElement.selectedIndex = foundOption.index;
                foundElement.dispatchEvent(new Event('change'));
              }
            }
        })
    })
    
    // Close dropdown onclick outside
    document.addEventListener('click', (e) => {
        const toggle = document.querySelector('.dropdown__switch');
        if(toggle){
          const element = e.target
      
          if (element == toggle) return;
      
          const isDropdownChild = element.closest('.dropdown__filter')		
          
          if (!isDropdownChild) {
              toggle.checked = false
          }
        }
    })
  
    /*******COUNTDOWN TIMER FUNCTIONALITY*******/
  
    class CountdownTimer extends HTMLElement {
      constructor() {
        super();
    
        this.parent = this.closest('.product-countdown');
        this.date = new Date(Date.parse(this.dataset.date)).getTime();
    
        if (isNaN(this.date)) {
          this.date = new Date(this.dataset.date.replace(/-/g, "/")).getTime();
    
          if (isNaN(this.date)) {
            this.unload();
            return;
          }
        }
    
        theme.initWhenVisible({
          element: this,
          callback: this.init.bind(this),
          threshold: 200
        });
      }
    
      init() {
        this.timer();
        this.dataset.interval = setInterval(this.timer.bind(this), 1000);
      }
    
      timer() {
        const now = new Date(),
          countTo = new Date(this.date),
          timeDifference = (countTo - now);
    
        const secondsInADay = 60 * 60 * 1000 * 24,
          secondsInAHour = 60 * 60 * 1000;
    
        const days = Math.floor(timeDifference / (secondsInADay) * 1);
        const hours = Math.floor((timeDifference % (secondsInADay)) / (secondsInAHour) * 1);
        const mins = Math.floor(((timeDifference % (secondsInADay)) % (secondsInAHour)) / (60 * 1000) * 1);
        const secs = Math.floor((((timeDifference % (secondsInADay)) % (secondsInAHour)) % (60 * 1000)) / 1000 * 1);
  
        if (timeDifference < 0) {
          this.unload();
          return;
        }
        
        if (this.dataset.compact == 'true') {
          const dayHTML = days > 0 ? `<div class="countdown__item"><span>${days}${theme.dateStrings.d}</span></div>` : '';
          const otherHTML = `<div class="countdown__item"><span>${hours > 9 ? hours : '0' + hours}:${mins > 9 ? mins : '0' + mins}:${secs > 9 ? secs : '0' + secs}</span></div>`;
      
          this.innerHTML = dayHTML + otherHTML;
        }
        else {
          const dayHTML = days > 0 ? `<div class="countdown__item"><span class="counter-digits">${days > 9 ? days : '0' + days}</span> <span class="counter--label">${days == 1 ? theme.dateStrings.day : theme.dateStrings.days}</span></div>` : '';
          const hourHTML = `<div class="countdown__item"><span class="counter-digits">${hours > 9 ? hours : '0' + hours}</span> <span class="counter--label">${hours == 1 ? theme.dateStrings.hour : theme.dateStrings.hours}</span></div>`;
          const minHTML = `<div class="countdown__item"><span class="counter-digits">${mins > 9 ? mins : '0' + mins}</span> <span class="counter--label">${mins == 1 ? theme.dateStrings.minute : theme.dateStrings.minutes}</span></div>`;
          const secHTML = `<div class="countdown__item"><span class="counter-digits">${secs > 9 ? secs : '0' + secs}</span> <span class="counter--label">${secs == 1 ? theme.dateStrings.second : theme.dateStrings.seconds}</span></div>`;
    
          this.innerHTML = dayHTML + hourHTML + minHTML + secHTML;
        }
      }
    
      unload() {
        if (this.dataset.interval) {
          clearInterval(this.dataset.interval);
        }
    
        this.classList.add('hidden');
        if (this.parent) {
          this.parent.classList.add('hidden');
        }
      }
    }
    customElements.define('countdown-timer', CountdownTimer);
    
  })();
});